import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/core/components/ui/select';
import { ApplicationType, ApplicationTypeLabels } from '../../types/translation-types';

interface ApplicationTypeSelectProps {
  value: ApplicationType | null;
  onChange: (value: ApplicationType | null) => void;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  placeholder?: string;
}

export function ApplicationTypeSelect({
  value,
  onChange,
  disabled = false,
  className,
  required = false,
  placeholder = 'Target Application Type',
}: ApplicationTypeSelectProps) {
  const displayPlaceholder = required ? `${placeholder} *` : placeholder;

  return (
    <Select
      value={value?.toString() ?? ''}
      onValueChange={(val) => onChange(val ? (Number(val) as ApplicationType) : null)}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={displayPlaceholder} />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(ApplicationTypeLabels).map(([key, labelText]) => (
          <SelectItem key={key} value={key}>
            {labelText}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
